import { Component, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

//Services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from 'src/app/core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import { HiringService } from '../../../pages/hiring/services/hiring.service';
import { HomeService } from 'src/app/pages/home/services/home.service';

//Modals
import { AddressConfirmationModalComponent } from '../../employee/personal-info/address-confirmation-modal/address-confirmation-modal.component';

@Component({
  selector: 'app-review-w4-modal',
  templateUrl: './review-w4-modal.component.html',
  styleUrls: ['./review-w4-modal.component.css'],
})
export class ReviewW4ModalComponent implements OnInit {
  @ViewChild('W4Form', { static: false }) W4Form: NgForm;
  @ViewChild('signaturePad', { static: false }) signaturePad;
  @Input() id: string;
  @Input() viewMode: boolean;
  portalSettings: any;
  employeeInfo: any;
  format: string;
  mobileMode = false;
  currencyFormatSymbols: any;
  currencySymbol: string;
  currentYear: number;
  formData: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  datePickerOptions: {
    dateInputFormat: string;
    containerClass: string;
    showTodayButton: boolean;
    showClearButton: boolean;
    clearPosition: string;
    showWeekNumbers: boolean;
    adaptivePosition: boolean;
  };
  alreadySubmitted = false;
  stateList: any[];
  submitSignImg: string;
  validateCheck = false;
  alert: string;
  isAddressValidationEnabled = false;
  enableCheckboxSign = false;
  latitude: any;
  longitude: any;
  signatureNEmpty = false;
  rawImgData: any;
  hideClick = false;
  showClickMsg = false;
  redBorder = false;
  fillW4 = false;
  fillW4URL = '/careers/fillw4';
  tasksURL = '/careers/tasks';
  signaturePadOptions: Object = {
    canvasWidth: 470,
    canvasHeight: 150,
  };
  isReturnFromEmployerW4Form = false;
  employerCommentW4Form: string;

  constructor(
    portalSettingsService: PortalSettingsService,
    @Optional() employeeInfoService: EmployeeInfoService,
    private utilityService: UtilityService,
    private hiringService: HiringService,
    @Optional() private activeModal: NgbActiveModal,
    private homeService: HomeService,
    private modalService: NgbModal,
    private router: Router
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnInit(): void {
    this.mobileMode = this.utilityService.isMobileMode();
    this.format = this.utilityService.getDateFormat();
    this.isAddressValidationEnabled = this.portalSettings.IsAddressValidated.ConfigValue == '1';
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == '1';
    this.datePickerOptions = {
      dateInputFormat: this.format.toUpperCase(),
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
      adaptivePosition: true,
    };
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo?.PRCo);
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: NgxCurrencyInputMode.Natural };
    this.currentYear = new Date().getFullYear();
    this.formData.IsExempt = false;
    this.formData.SignDate = new Date(moment().format('MM/DD/YYYY'));

    if (parseInt(new Date().toString()) < parseInt(new Date('2020/01/01').toString())) this.formData.showNewForm = false;
    else this.formData.showNewForm = true;

    this.getRouteData();

    if (this.fillW4) {
      this.getInfoByOnboardID();
    }

    this.getDependentLookupByColumnName();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }

    if (this.fillW4) {
      this.getW4Info(1);
    } else {
      this.getW4Info(2);
    }
  }

  getRouteData() {
    var path = window.location.pathname;
    if (path != null && path.length > 1) {
      if (path == this.fillW4URL.toLowerCase()) {
        this.fillW4 = true;
      } else {
        this.alreadySubmitted = true;
      }
    }
  }

  getDependentLookupByColumnName() {
    this.hiringService.getDependentLookupByColumnName('State', null).then((response: any[]) => {
      if (response != null) {
        this.stateList = response;
      }
    });
  }

  getInfoByOnboardID() {
    this.hiringService.getInfoByOnboardID().then((response: any) => {
      if (response != null) {
        this.isReturnFromEmployerW4Form = response.IsReturnFromEmployerW4Form;
        this.employerCommentW4Form = response.EmployerCommentW4Form;
        if (response.DateSubmitted != null) this.alreadySubmitted = true;
      } else this.alreadySubmitted = false;
    });
  }

  switchLanguage() {
    if (this.formData.FormLanguage == 'EN') this.formData.FormLanguage = 'ES';
    else this.formData.FormLanguage = 'EN';
  }

  getW4Info(step: number): void {
    this.hiringService.getW4Info(this.id, step).then((response: any) => {
      if (response != null && response.length > 0) {
        const w4Info = response[0];
        for (const key in w4Info) {
          if (key == 'IsDiffLastName') {
            if (w4Info[key] != null) {
              this.formData.IsDiffLastName = w4Info[key];
            }
          } else if (key == 'IsExempt') {
            if (w4Info[key] != null) {
              this.formData.IsExempt = w4Info[key];
            }
          } else if (key == 'SignDate') {
            if (w4Info[key] != null) {
              this.formData.SignDate = new Date(moment(w4Info[key], this.format.toUpperCase()).utc().format('MM/DD/YYYY'));
            }
          } else if (key == 'SignatureBinary' && this.alreadySubmitted) {
            if (w4Info[key] != null) {
              //#600941 - Display the image in the signature pad
              this.submitSignImg = 'data:image/png;base64,' + w4Info[key];
            }
          } else if (key == 'DateFirstEmployment') {
            if (w4Info[key] != null) {
              this.formData.DateFirstEmployment = new Date(moment(w4Info[key]).utc().format('MM/DD/YYYY'));
            }
          } else {
            this.formData[key] = w4Info[key];
          }
        }
        this.employerCommentW4Form = this.formData.EmployerCommentW4Form;
        if (this.formData.MaritalStatus == null) this.formData.MaritalStatus = null;

        if (this.fillW4) this.formData.SignatureBinary = null;

        if (
          this.formData.SignatureDate != null &&
          new Date(
            parseInt(moment(this.formData.SignatureDate).utc().format('YYYY')),
            parseInt(moment(this.formData.SignatureDate).utc().format('MM')) - 1,
            parseInt(moment(this.formData.SignatureDate).utc().format('DD')),
            0,
            0,
            0,
            0
          ) < new Date('2020/01/01')
        ) {
          this.formData.showNewForm = false;
        } else if (
          this.formData.SignatureDate != null &&
          new Date(
            parseInt(moment(this.formData.SignatureDate).utc().format('YYYY')),
            parseInt(moment(this.formData.SignatureDate).utc().format('MM')) - 1,
            parseInt(moment(this.formData.SignatureDate).utc().format('DD')),
            0,
            0,
            0,
            0
          ) > new Date('2020/01/01')
        ) {
          this.formData.showNewForm = true;
        }
      }
    });
  }

  isExemptUpdated() {
    setTimeout(() => {
      if (this.formData.showNewForm && this.formData.IsExempt) {
        this.formData.MaritalStatus = null;
        this.formData.MultiJobs2020 = null;
        this.formData.QualChildAmount = null;
        this.formData.OtherDependentAmount = null;
        this.formData.DependentAmt2020 = null;
        this.formData.OtherIncome2020 = null;
        this.formData.Deductions2020 = null;
        this.formData.AdditionalAmount = null;
      }
    });
  }

  submit(isAddressInvalid: boolean) {
    isAddressInvalid = typeof isAddressInvalid == 'undefined' ? null : isAddressInvalid == true;
    this.formData.isReturnFromEmployerW4Form = false;
    this.hiringService.insertUpdateW4(this.formData).then((response: any) => {
      if (response != null) {
        this.validateCheck = false;
        if (response.success) {
          this.router.navigate(['/careers/tasks']);
        }
      }
    });
  }

  dirty() {
    if (this.formData.DependentAmt2020 || this.formData.OtherIncome2020 || this.formData.Deductions2020 || this.formData.AdditionalAmount)
      this.formData.IsExempt = false;
  }

  step3Calculate() {
    if (this.formData.QualChildAmount != null && this.formData.OtherDependentAmount != null)
      this.formData.DependentAmt2020 = this.formData.QualChildAmount + this.formData.OtherDependentAmount;
  }

  saveW4() {
    this.validateCheck = true;
    if (!this.W4Form.form.invalid) {
      this.alert = null;
      this.hiringService
        .updateW4ByOnboardIDPart2(
          this.id,
          this.formData.EmployerNameAddress,
          null,
          this.formData.EIN,
          this.formData.DateFirstEmployment != null ? moment(this.formData.DateFirstEmployment).format('YYYY-MM-DD') : ''
        )
        .then((response: any) => {
          this.validateCheck = false;
          if (response != null && response.success) {
            this.activeModal.close('success');
          } else {
            this.alert = response.error;
          }
        });
    } else {
      this.alert = 'Please fill out all required fields.';
    }
  }

  saveFillW4() {
    this.validateCheck = true;
    this.checkSigned();
    this.checkSSN();

    if (
      !this.W4Form.form.invalid &&
      ((this.formData.MaritalStatus != null && !this.formData.IsExempt) ||
        (this.formData.IsExempt && this.formData.MaritalStatus == null)) &&
      this.formData.SSN != null
    ) {
      this.alert = null;
      if (this.signatureNEmpty) {
        if (this.formData.SSN != null) {
          this.formData.SSN = this.formData.SSN.split('-').join('');
        }
        if (this.formData.SignDate != null) {
          this.formData.SignDateStr = moment(this.formData.SignDate).utc().format('MM/DD/YYYY');
        }

        if (this.formData.typeSign) {
          this.formData.SignatureBinary = this.rawImgData;
        } else {
          if (this.formData.SignatureBinary == null)
            this.formData.SignatureBinary = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
        }

        if (this.longitude != null) this.formData.longitude = this.longitude;
        if (this.latitude != null) this.formData.latitude = this.latitude;
        for (const [key, val] of Object.entries(this.formData)) {
          if (val == '' && val != 0) this.formData[key] = null;
        }

        if (!this.isAddressValidationEnabled) {
          this.submit(true);
          return;
        }

        //------------hold it

        this.validateAddress();
        return;
      } else {
        window.scrollTo(0, 0);
        this.alert = 'Please fill out all required fields.';
      }
    } else {
      window.scrollTo(0, 0);
      this.alert = 'Please fill out all required fields.';
    }
  }

  validateAddress() {
    this.hiringService.validateAddress(this.formData.Address, this.formData.City, this.formData.State, this.formData.Zip).then(
      (response: any) => {
        if (response != null) {
          if (response.IsValid == false) {
            this.openAddressValidationModal(response.SuggestedAddressString, response.OriginalAddressString, response.SuggestedAddress);
            return;
          } else {
            this.submit(true);
          }
        } else {
          var address = this.formData.Address + ', ' + this.formData.City + ', ' + this.formData.State + ' ' + this.formData.Zip;
          this.openAddressValidationModal(null, address, null);
        }
      },
      error => {
        var address = this.formData.Address + ', ' + this.formData.City + ', ' + this.formData.State + ' ' + this.formData.Zip;
        this.openAddressValidationModal(null, address, null);
      }
    );
  }

  openAddressValidationModal(suggestedAddress: string, originalAddress: string, suggestedAddressComponents: any) {
    const modalRef = this.modalService.open(AddressConfirmationModalComponent, { size: 'sm', backdrop: 'static' });
    modalRef.componentInstance.suggestedAddress = suggestedAddress;
    modalRef.componentInstance.badAddress = originalAddress;

    modalRef.result.then(userChoice => {
      // User chose bad address
      if (userChoice == 0) {
        this.submit(true);
      }
      // User chose suggested address
      else if (userChoice == 1) {
        this.formData.Address = suggestedAddressComponents.Address;
        this.formData.City = suggestedAddressComponents.City;
        this.formData.State = suggestedAddressComponents.State;
        this.formData.Zip = suggestedAddressComponents.PostalCode;
        this.submit(false);
      }
      // User chose to cancel
      else {
        this.utilityService.closeModal();
      }
    });
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  }

  clickSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.homeService.getTypeSign(type).then((response: any) => {
        this.rawImgData = response;
        this.submitSignImg = 'data:image/png;base64,' + response;
        this.signatureNEmpty = true;
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  checkSigned() {
    if (this.signaturePad != null) {
      if (!this.signaturePad.isEmpty()) {
        this.redBorder = false;
        this.signatureNEmpty = true;
      } else {
        this.redBorder = true;
      }
    }
  }

  clear() {
    if (this.signaturePad != null) {
      if (!this.signaturePad.isEmpty()) {
        this.signaturePad.clear();
      }
      this.signatureNEmpty = false;
    }

    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  checkSSN() {
    if (this.formData.SSN != null) {
      if (this.formData.SSN.length != 11) this.formData.SSN = null;
    }
  }

  updateFormdata(data: string, field: any) {
    this.formData[field] = data;
  }

  closeClick() {
    this.activeModal.close();
  }

  routeToTask() {
    this.router.navigate(['/careers/tasks']);
  }
}
